export default function useCost() {
  const toPounds = (amount: number): number => {
    return amount / 1000
  }

  const toPence = (amount: number): number => {
    return amount / 10
  }

  const format = (price: number) => {
    if (Math.abs(price) > 1000) {
      let out = `£${(toPounds(Math.abs(price)).toFixed(2)).toLocaleString()}`
      if (price < 0) {
        out = `-${out}`
      }
      return out
    }
    return `${(toPence(price)).toLocaleString()}p`
  }

  const fromPence = (pence: number) => {
    return pence * 10
  }

  return {
    toPounds,
    toPence,
    format,
    fromPence,
  }
}
